<template>
    <div class="wrapper">
        <side-bar>
            <mobile-menu slot="content"></mobile-menu>
            <sidebar-link to="/preview">
                <i class="nc-icon nc-apple"></i>
                <p>Превью</p>
            </sidebar-link>
            <sidebar-link to="/categories" v-if="role === 302">
                <i class="nc-icon nc-notes"></i>
                <p>Категории</p>
            </sidebar-link>
            <span class="resetspan" @click="resetOffsets">
            <sidebar-link to="/templates">
                <i class="nc-icon nc-album-2"></i>
                <p>Шаблоны</p>
            </sidebar-link>
            </span>
            <sidebar-link to="/post/categories" v-if="role === 302">
                <i class="nc-icon nc-notes"></i>
                <p>Категории каруселей</p>
            </sidebar-link>
            <sidebar-link to="/posts" v-if="role === 302">
                <i class="nc-icon nc-single-copy-04"></i>
                <p>Карусели</p>
            </sidebar-link>
            <sidebar-link to="/memories" v-if="role === 302">
                <i class="nc-icon nc-light-3"></i>
                <p>Memories</p>
            </sidebar-link>
            <sidebar-link to="/calendar">
                <i class="nc-icon nc-watch-time"></i>
                <p>Календарь</p>
            </sidebar-link>
            <sidebar-link to="/frame/categories" v-if="role === 302">
                <i class="nc-icon nc-notes"></i>
                <p>Категории фреймов</p>
            </sidebar-link>
            <sidebar-link to="/frames" v-if="role === 302">
                <i class="nc-icon nc-puzzle-10"></i>
                <p>Фреймы</p>
            </sidebar-link>
            <sidebar-link to="/graphic/categories" v-if="role === 302">
                <i class="nc-icon nc-notes"></i>
                <p>Категории стикеров</p>
            </sidebar-link>
            <sidebar-link to="/graphics" v-if="role === 302">
                <i class="nc-icon nc-atom"></i>
                <p>Стикеры</p>
            </sidebar-link>
            <sidebar-link to="/font/categories" v-if="role === 302">
                <i class="nc-icon nc-notes"></i>
                <p>Категории шрифтов</p>
            </sidebar-link>
            <sidebar-link to="/fonts" v-if="role === 302">
                <i class="nc-icon nc-ruler-pencil"></i>
                <p>Шрифты</p>
            </sidebar-link>
            <sidebar-link to="/effect/categories" v-if="role === 302">
                <i class="nc-icon nc-notes"></i>
                <p>Категории эффектов</p>
            </sidebar-link>
            <sidebar-link to="/effects" v-if="role === 302">
                <i class="nc-icon nc-preferences-circle-rotate"></i>
                <p>Эффекты</p>
            </sidebar-link>
            <sidebar-link to="/music/categories" v-if="role === 302">
                <i class="nc-icon nc-single-copy-04"></i>
                <p>Категории музыки</p>
            </sidebar-link>
            <sidebar-link to="/new-music" v-if="role === 302">
                <i class="nc-icon nc-note-03"></i>
                <p>Музыка</p>
            </sidebar-link>
            <sidebar-link to="/tabs" v-if="role === 302">
                <i class="nc-icon nc-layers-3"></i>
                <p>Вкладки</p>
            </sidebar-link>
<!--            <sidebar-link to="/tags" v-if="role === 302">-->
<!--                <i class="nc-icon nc-tag-content"></i>-->
<!--                <p>Теги</p>-->
<!--            </sidebar-link>-->
            <sidebar-link to="/logs">
                <i class="nc-icon nc-cctv"></i>
                <p>Логи</p>
            </sidebar-link>
            <li class="sidebar-divider" v-if="role === 302"></li>
            <sidebar-link to="/nola-preview" v-if="role === 302">
                <i class="nc-icon nc-apple"></i>
                <p>Превью Nola</p>
            </sidebar-link>
            <li class="sidebar-divider" v-if="role === 302"></li>
            <sidebar-link to="/reports" v-if="role === 302">
                <i class="nc-icon nc-chart-bar-32"></i>
                <p>Отчеты</p>
            </sidebar-link>
            <sidebar-link to="/push-tasks" v-if="role === 302">
                <i class="nc-icon nc-notification-70"></i>
                <p>Рассылки</p>
            </sidebar-link>
<!--            <sidebar-link to="/icons">-->
<!--                <i class="nc-icon nc-atom"></i>-->
<!--                <p>Icons</p>-->
<!--            </sidebar-link>-->
        </side-bar>
        <div class="main-panel">
            <top-navbar></top-navbar>

            <dashboard-content @click="toggleSidebar">

            </dashboard-content>

            <content-footer></content-footer>
        </div>
    </div>
</template>
<style lang="scss">

    .resetspan {
        display: block;
        width: 100%;
    }

    // footer sticks to the bottom on short pages and goes after the content on long ones
    .main-panel {
        display: flex;
        flex-direction: column;

        > * {
            flex-shrink: 0;
        }

        // the theme's min-height on .content is not needed with flex and adds extra scroll
        .wrapper > & > .content {
            min-height: 0;
        }

        > .footer {
            margin-top: auto;
        }

        > :nth-last-child(2) {
            margin-bottom: 24px;
        }
    }

    .sidebar-divider {
        height: 0;
        margin: 10px 10px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);
        list-style: none;
        pointer-events: none;
    }

</style>
<script>
    import TopNavbar from './TopNavbar.vue'
    import ContentFooter from './ContentFooter.vue'
    import DashboardContent from './Content.vue'
    import MobileMenu from './MobileMenu.vue'

    export default {
        components: {
            TopNavbar,
            ContentFooter,
            DashboardContent,
            MobileMenu
        },
        data() {
            return {
                role: parseInt(localStorage.getItem('role')) || 0,
            }
        },
        methods: {
            toggleSidebar () {
                if (this.$sidebar.showSidebar) {
                    this.$sidebar.displaySidebar(false)
                }
            },
            resetOffsets: function() {
                localStorage.setItem('w_active_offset', 0);
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/DashboardLayout.vue